import { zodResolver } from '@hookform/resolvers/zod';
import { onboardingAdmin } from 'further-ui/validations';
import useOnboardingSettings from 'hooks/lp/data/vehicle/useOnboardingSettings';
import api from 'lib/trpcClient';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

type FormValues = z.infer<typeof onboardingAdmin.SaveOnboardingSettingsInput>;

export default function useReviewSettings(vehicleId: string) {
  const { onboardingSettings, updateOnboardingSettings, isUpdating } =
    useOnboardingSettings(vehicleId);

  const { control, setValue, getValues } = useForm<FormValues>({
    resolver: zodResolver(onboardingAdmin.SaveOnboardingSettingsInput),
    defaultValues: onboardingSettings,
  });

  const [usersInVehicle] = api.adminUser.listCurrentFirmUsers.useSuspenseQuery({
    vehicleId,
  });

  const updateReviewSettings = () => {
    updateOnboardingSettings({
      reviewSettings: getValues().reviewSettings,
    });
  };

  const handleChangeInvestorDetailsReviewerIds = (value: Array<string>) => {
    setValue('reviewSettings.investorDetailsReviewerIds', value);
    if (value.length > 0) {
      setValue('reviewSettings.investorDetailsNeedsReview', true);
    }
    updateReviewSettings();
  };

  const handleChangeClassificationReviewerIds = (value: Array<string>) => {
    setValue('reviewSettings.classificationReviewerIds', value);
    if (value.length > 0) {
      setValue('reviewSettings.classificationNeedsReview', true);
    }
    updateReviewSettings();
  };
  const handleChangeTaxDetailsReviewerIds = (value: Array<string>) => {
    setValue('reviewSettings.taxDetailsReviewerIds', value);
    if (value.length > 0) {
      setValue('reviewSettings.taxDetailsNeedsReview', true);
    }
    updateReviewSettings();
  };

  const handleChangeInvestorDetailsNeedsReview = (value: boolean) => {
    setValue('reviewSettings.investorDetailsNeedsReview', value);
    if (!value) {
      setValue('reviewSettings.investorDetailsReviewerIds', []);
    }
    updateReviewSettings();
  };
  const handleChangeClassificationNeedsReview = (value: boolean) => {
    setValue('reviewSettings.classificationNeedsReview', value);
    if (!value) {
      setValue('reviewSettings.classificationReviewerIds', []);
    }
    updateReviewSettings();
  };
  const handleChangeTaxDetailsNeedsReview = (value: boolean) => {
    setValue('reviewSettings.taxDetailsNeedsReview', value);
    if (!value) {
      setValue('reviewSettings.taxDetailsReviewerIds', []);
    }
    updateReviewSettings();
  };

  const adminUsersOptions = usersInVehicle.map((user) => ({
    label: `${user.firstName} ${user.lastName}`,
    value: user.id,
  }));

  return {
    control,
    adminUsersOptions,
    handleChangeInvestorDetailsReviewerIds,
    handleChangeClassificationReviewerIds,
    handleChangeTaxDetailsReviewerIds,
    handleChangeInvestorDetailsNeedsReview,
    handleChangeClassificationNeedsReview,
    handleChangeTaxDetailsNeedsReview,
    isLoading: isUpdating,
  };
}
